.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
}

.errorContainer {
  display: flex;
  align-items: center;
  gap: var(--spacingSm);
}

.error {
  color: var(--paletteRed1);
}
